import React, { useEffect, useState } from "react";
import "./LockPeriod.css";
import { ethers } from "ethers";

const LockPeriod = ({ contract, account }) => {
  const [latestStake, setLatestStake] = useState(null);
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const fetchStakingHistory = async () => {
      try {
        let index = 0; // Start checking from the first stake
        let activeFound = false;

        while (!activeFound) {
          try {
            const stake = await contract.stakers(account, index);
            if (stake.active) {
              setLatestStake({
                amount: ethers.utils.formatUnits(stake.amount, 18),
                startTime: new Date(stake.startTime * 1000),
                duration: stake.duration,
              });
              activeFound = true; // Exit after the first active stake is found
            } else {
              index++; // Increment index if not active
            }
          } catch (error) {
            console.log("No more stakes or error fetching stakes.");
            break; // Exit loop if any error occurs (likely no more stakes)
          }
        }
      } catch (error) {
        console.error("Error fetching staking history:", error);
      }
    };

    if (contract && account) {
      fetchStakingHistory();
    }
  }, [contract, account]);

  useEffect(() => {
    const interval = latestStake
      ? setInterval(() => {
          const now = new Date();
          const endTime = new Date(
            latestStake.startTime.getTime() + latestStake.duration * 1000
          );
          const delta = endTime - now;

          if (delta > 0) {
            const days = Math.floor(delta / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
              (delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
              (delta % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((delta % (1000 * 60)) / 1000);
            setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
          } else {
            setTimeLeft("Staking period has ended.");
            clearInterval(interval);
          }
        }, 1000)
      : null;

    return () => clearInterval(interval);
  }, [latestStake]);

  return (
    <div className="lock-period">
      <h2>Lock Period</h2>
      <div className="lock-details">
        <div className="inside-lock-details">
          <div>
            <p className="weekday">
              {new Date().toLocaleDateString("en-US", { weekday: "long" })}
            </p>
            <p className="date">
              {latestStake
                ? latestStake.startTime.toLocaleDateString()
                : "Haven't Staked any Tokens"}
            </p>
          </div>
          <div className="timer">
            {timeLeft && (
              <>
                <div>
                  <span className="time-value">{timeLeft.split(" ")[0]}</span>
                  <span className="time-unit">Day</span>
                </div>
                <div>
                  <span className="time-value">{timeLeft.split(" ")[1]}</span>
                  <span className="time-unit">Hour</span>
                </div>
                <div>
                  <span className="time-value">{timeLeft.split(" ")[2]}</span>
                  <span className="time-unit">Mins</span>
                </div>
                <div>
                  <span className="time-value">{timeLeft.split(" ")[3]}</span>
                  <span className="time-unit">Sec</span>
                </div>
              </>
            )}
          </div>
          {latestStake && (
            <p className="amount">{latestStake.amount} INFINITY</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LockPeriod;
